import initModals from './components/modal';
import initAppearAnim from "./utils/appear-anim";
import initDropdown from "./utils/dropdown";
import initTabs from './utils/tabs';
import initReadMore from './utils/read-more';
import initFormFilters from "./components/form-filters";
import initHeaderNavigation from './template-parts/header-navigation';
import initHeaderAccueil from "./blocks/header-accueil";
import initCarouselThematiques from "./blocks/carousel-thematiques";
import initInteractiveMap from "./blocks/carte-interactive";
import { initYoutubeIframe } from './components/youtube-iframe';
import initPasswordToggler from './components/password-toggler';
import { initSearchAutocomplete, initSearchNbPerPageSelect } from './template-parts/search';
import initAlert from './components/alert';
import initFavorites from './components/favorites';
import initNotificationsPreferences from './components/notifications-preferences';
import initArchivePartenaires from './template-parts/archive-partenaires';
import initRetrievePassword from './template-parts/profile-password';
import initDownloadBlob from './components/download-blob';
import initbaseDocumentaireScroll from './template-parts/base-documentaire-scroll';
import { initAnnuaireSearchAutocomplete } from './template-parts/annuaire-search';
import { initBaseDocumentaireSearchAutocomplete } from './template-parts/base-documentaire-search';
import initRegisterForm from './components/register-form';
import initProfileInfoForm from './components/profile-info-form';
import initProfileNewsletterForm from './components/profile-newletter-form';
import initTestimonials from './blocks/testimonials';
import initCarouselCarreauGasc from './blocks/college-carreau-gasc';
import initFiltersWrapper from './components/filters';
import initSingleContentSummary from './template-parts/single-content-summary';
import initFormulaireCF7Redirection from './utils/formulaireCF7redirection';
import initCarouselPosts from './components/carousel-posts';
// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);

// Utils
initAppearAnim();
initDropdown();
initTabs();
initReadMore();
initFormulaireCF7Redirection();
// Template parts
initHeaderNavigation();
initSearchNbPerPageSelect();
initSearchAutocomplete();
initArchivePartenaires();
initDownloadBlob();
initbaseDocumentaireScroll();
initAnnuaireSearchAutocomplete();
initBaseDocumentaireSearchAutocomplete();
initSingleContentSummary();
// Blocks
initHeaderAccueil();
initCarouselThematiques();
initInteractiveMap();
initTestimonials();
initCarouselCarreauGasc();
// Components
initFormFilters();
initModals();
initYoutubeIframe();
initPasswordToggler();
initAlert();
initFavorites();
initNotificationsPreferences();
initRetrievePassword();
initRegisterForm();
initProfileInfoForm();
initProfileNewsletterForm();
initFiltersWrapper();
initCarouselPosts();

